import slider from '../components/slider';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    slider.init();
    // eslint-disable-next-line no-undef
    UIkit.modal('#cinquemaggio').show();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js